import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { RemoveSellerFromDealerAction } from '@core/states/dealer/dealer.actions';
import { Store } from '@ngxs/store';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-remove-seller-dialog',
  templateUrl: './remove-seller-dialog.component.html',
  styleUrls: ['./remove-seller-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent, MatDialogClose],
})
export class RemoveSellerDialogComponent {
  private store = inject(Store);
  dialogRef = inject<MatDialogRef<RemoveSellerDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA, { optional: true });

  confirmRemove() {
    this.store.dispatch(new RemoveSellerFromDealerAction(this.data.seller));
    this.dialogRef.close();
  }
}
